// Globals
import { ChangeEvent } from 'react';
import { TableColumnsType } from 'antd';
import { TFunction } from 'i18next';

// Components
import { Button, Input } from '@/ui';
import { StyledButtons, StyledSearchWrapper, StyledTruncate } from '../components';
import { PenIcon, TrashIcon } from '@/icons';

// Models
import { IInterLink } from '@/models/linkingTool.model';
import { renderDate } from '@/utils';
import { DateFormats } from '@/constants/dates';

export const linkingToolColumns = (
  t: TFunction,
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void,
  onDelete?: (record: IInterLink) => void,
  onEdit?: (record: IInterLink) => void,
): TableColumnsType<IInterLink> => [
  {
    title: (
      <StyledSearchWrapper>
        <span>{t('column_link')}</span>
        <Input onChange={onChange} size="small" placeholder={t('placeholder_search')} />
      </StyledSearchWrapper>
    ),
    dataIndex: 'pagePath',
    key: 'pagePath',
    width: 400,
    render: (pagePath: string) => (
      <StyledTruncate $width="15rem" title={pagePath}>
        {pagePath}
      </StyledTruncate>
    ),
  },
  {
    dataIndex: 'createdAt',
    key: 'createdAt',
    width: 200,
    title: t('column_date'),
    render: (createdAt: string) => <StyledTruncate>{renderDate(createdAt, DateFormats.DATE_WITH_TIME)}</StyledTruncate>,
  },
  {
    title: t('column_action'),
    key: 'action',
    width: 150,
    render: (_, record) => (
      <StyledButtons>
        <Button
          icon={<PenIcon />}
          type="primary"
          size="small"
          block
          onClick={() => {
            onEdit?.(record);
          }}
        />
        <Button
          type="primary"
          size="small"
          icon={<TrashIcon />}
          danger
          block
          onClick={() => {
            onDelete?.(record);
          }}
        />
      </StyledButtons>
    ),
  },
];
